import styled from 'styled-components'

import colors from 'styles/colors'

const mockOptions: Array<{ label: string; value: number }> = [
    {
        label: '$10',
        value: 10
    },
    {
        label: '$30',
        value: 30
    },
    {
        label: '$50',
        value: 50
    },
    {
        label: '$100',
        value: 100
    },
    {
        label: '$200',
        value: 200
    }
]

const FundsRadioGroup = ({
    options = mockOptions,
    selected,
    onChange
}: {
    options?: Array<{ label: string; value: string | number }>
    selected: string | number
    onChange: (_value: number) => void
}) => {
    const setSelectedClass = (
        selected: string | number,
        optionValue: string | number
    ) => {
        if (selected === optionValue) {
            return 'radioLabelSelected'
        }

        return 'radioLabel'
    }

    return (
        <GroupContainer>
            {options.map(option => (
                <RadioLabel
                    key={option.label}
                    htmlFor={option.label}
                    className={setSelectedClass(selected, option.value)}
                >
                    <input
                        id={option.label}
                        type='radio'
                        name='FundsRadioGroup'
                        value={option.value}
                        onChange={event =>
                            !!onChange && onChange(parseInt(event.target.value))
                        }
                    />
                    {option.label}
                </RadioLabel>
            ))}
        </GroupContainer>
    )
}

const GroupContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`

const RadioLabel = styled.label`
    width: 6.2rem;
    height: 3.6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0.6;
    font-weight: 600;
    font-size: 1.4rem;
    border: 1px solid ${colors.black};
    border-radius: 160px;
    margin-right: 5px;

    input[type='radio'] {
        width: 0;
        height: 0;
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }

    &:last-child {
        margin-right: 0;
    }

    &.radioLabelSelected {
        background: ${colors.black157deg};
        color: ${colors.white};
    }
`

export default FundsRadioGroup
